module.exports = __webpack_public_path__ + "img/transparency-commitment-outline.dbebc54f.svg";